import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const TriggerStatusKeys = new Set([
  'workflows.is_active',
  'keywords.is_active',
  'keywords.status',
  'workflows.status',
])

export const isTriggerStatusWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  TriggerStatusKeys.has(filterItem.key)
